// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1V2Ky","imageUploader":"EGiftCard_imageUploader__5Wkmy"};